import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT } from "const"
import { mtGroupsRoute } from "client/parts/routes"
import { hasAccess } from "client/utils"
import {
    PRM_GROUP,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    DivInput,
    Textarea,
    UserIcon,
    Button,
} from "client/components"


const Form = () => {
    const group = useSelector((state: StoreType) => state.group.groupView)
    const userList = useSelector((state: StoreType) => state.user.userList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${mtGroupsRoute}/${EDIT}/${group.id}`

    const editAccess = hasAccess(PRM_GROUP, EDIT)
    const allowedToEdit = group.accountId === userData.accountId
        ? editAccess || group.creator === userData.userId
        : false

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={group.name} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={group.description} readOnly />
                    </FormGroup>
                    {
                        group.creator && group.accountId === userData.accountId && (
                            <FormGroup>
                                <Label>{lang.createdBy}</Label>
                                <DivInput>
                                    <UserIcon user={userList[group.creator]} size="sm" />
                                </DivInput>
                            </FormGroup>
                        )
                    }
                </Col>
                {
                    allowedToEdit && (
                        <Col xs={12}>
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        </Col>
                    )
                }
            </Row>
        </PageForm>
    )
}
export default Form
